import React from 'react';
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch';
import { booleanTestIdFormatter } from '../../../utils/helpers';

interface MandatoryToggleSwitchProps {
  uniqueKey: string;
  schema: any;
  onChange: (event: any) => void;
}

const MandatoryToggleSwitch: React.FC<MandatoryToggleSwitchProps> = ({ uniqueKey, schema, onChange }) => {
  return (
    <div className="ToggleWrap">
      <ToggleSwitch
        testId={booleanTestIdFormatter("cs-ct-field-group-mandatory", schema.mandatory)}
        name={`${uniqueKey}.mandatory`}
        label="Mandatory"
        checked={schema.mandatory}
        onChange={onChange}
      />
    </div>
  );
};

export default MandatoryToggleSwitch;
